import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconSwimmingPool: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17 16C17.7 16 18.3 15.6 18.9 15.2C19.8 14.6 20.7 14 22 14V16C21.4318 16 20.9954 16.2636 20.4768 16.5768C20.3565 16.6494 20.2318 16.7247 20.1 16.8C19.2 17.4 18.3 18 17 18C15.7993 18 14.8546 17.4029 14.0869 16.9177C14.0234 16.8776 13.9611 16.8382 13.9 16.8C13.3 16.4 12.7 16 12 16C11.3 16 10.7 16.4 10.1 16.8C9.2 17.4 8.3 18 7 18C5.7 18 4.8 17.4 3.9 16.8C3.3 16.4 2.7 16 2 16V14C3.15976 14 4.00117 14.4775 4.80824 14.9356C4.90583 14.991 5.00291 15.0461 5.1 15.1L6 15.7V5C6 3.3 7.3 2 9 2C10.7 2 12 3.3 12 5C12 5.6 11.6 6 11 6C10.4 6 10 5.6 10 5C10 4.4 9.6 4 9 4C8.4 4 8 4.4 8 5V9H14V5C14 3.3 15.3 2 17 2C18.7 2 20 3.3 20 5C20 5.6 19.6 6 19 6C18.4 6 18 5.6 18 5C18 4.4 17.6 4 17 4C16.4 4 16 4.4 16 5V15.7C16.3 15.9 16.6 16 17 16ZM12 14C12.8 14 13.4 14.2 14 14.5V11H8V15.8L8.9 15.2C9.8 14.6 10.7 14 12 14ZM15.1 19.2C15.7 19.6 16.3 20 17 20C17.7 20 18.3 19.6 18.9 19.2C19.8 18.6 20.7 18 22 18V20C21.4318 20 20.9954 20.2636 20.4768 20.5768C20.3565 20.6494 20.2318 20.7247 20.1 20.8C19.2 21.4 18.3 22 17 22C15.7993 22 14.8546 21.4029 14.0869 20.9177C14.0234 20.8776 13.9611 20.8382 13.9 20.8C13.3 20.4 12.7 20 12 20C11.3 20 10.7 20.4 10.1 20.8C9.2 21.4 8.3 22 7 22C5.7 22 4.8 21.4 3.9 20.8C3.3 20.4 2.7 20 2 20V18C3.3 18 4.2 18.6 5.1 19.2C5.7 19.6 6.3 20 7 20C7.7 20 8.3 19.6 8.9 19.2C9.8 18.6 10.7 18 12 18C13.3 18 14.2 18.6 15.1 19.2Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
